import { Release } from '@repo/types/release';

const HAS_ACCESS_KEY = 'has_access';

const HAS_LEFT_FEEDBACK = 'has_left_feedback';

const getCurrentStorage = (key: string): string[] => {
  const storage = localStorage.getItem(key);
  return storage ? JSON.parse(storage) : [];
};

const getHasPromoAccess = (catNr: Release['catNr']) => {
  const currentStorage = getCurrentStorage(HAS_ACCESS_KEY);
  return currentStorage.includes(catNr);
};

const setHasPromoAccess = (catNr: Release['catNr']) => {
  const currentStorage = getCurrentStorage(HAS_ACCESS_KEY);
  localStorage.setItem(
    HAS_ACCESS_KEY,
    JSON.stringify([...currentStorage, catNr]),
  );
};

const getHasLeftFeedback = (catNr: Release['catNr']) => {
  const currentStorage = getCurrentStorage(HAS_LEFT_FEEDBACK);
  return currentStorage.includes(catNr);
};

const setHasLeftFeedback = (catNr: Release['catNr']) => {
  const currentStorage = getCurrentStorage(HAS_LEFT_FEEDBACK);
  localStorage.setItem(
    HAS_LEFT_FEEDBACK,
    JSON.stringify([...currentStorage, catNr]),
  );
};

export const storedInteractions = {
  getHasPromoAccess,
  setHasPromoAccess,
  getHasLeftFeedback,
  setHasLeftFeedback,
};
